/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { utils, Contract, ContractFactory } from "ethers";
const _abi = [
    {
        inputs: [
            {
                internalType: "contract ISuperfluid",
                name: "host",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "NotAcceptedSuperToken",
        type: "error",
    },
    {
        inputs: [],
        name: "NotImplemented",
        type: "error",
    },
    {
        inputs: [],
        name: "UnauthorizedHost",
        type: "error",
    },
    {
        inputs: [],
        name: "CFAV1_TYPE",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "HOST",
        outputs: [
            {
                internalType: "contract ISuperfluid",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "afterAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "afterReceiverHolder",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "afterSenderHolder",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementCreated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementTerminated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        name: "beforeAgreementUpdated",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "activateOnCreated",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "activateOnUpdated",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "activateOnDeleted",
                type: "bool",
            },
        ],
        name: "getConfigWord",
        outputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
        ],
        name: "isAcceptedSuperToken",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lastUpdateHolder",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "oldFlowRateHolder",
        outputs: [
            {
                internalType: "int96",
                name: "",
                type: "int96",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bool",
                name: "activateOnCreated",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "activateOnUpdated",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "activateOnDeleted",
                type: "bool",
            },
        ],
        name: "selfRegister",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "acceptedSuperToken",
                type: "address",
            },
            {
                internalType: "bool",
                name: "accepted",
                type: "bool",
            },
        ],
        name: "setAcceptedSuperToken",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "int96",
                name: "flowRate",
                type: "int96",
            },
        ],
        name: "startStream",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
export class CFASuperAppBaseTester__factory extends ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(host, overrides) {
        return super.deploy(host, overrides || {});
    }
    getDeployTransaction(host, overrides) {
        return super.getDeployTransaction(host, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    }
}
CFASuperAppBaseTester__factory.bytecode = _bytecode;
CFASuperAppBaseTester__factory.abi = _abi;
//# sourceMappingURL=CFASuperAppBaseTester__factory.js.map